import * as React from 'react';
import {CloseIcon, Dialog, Flex, Text} from "@fluentui/react-northstar";
import EditInput from "../Utils/EditInput";
import languageObject from "../../translations";

/**
 * Folder Name Selector Dialog props
 */
interface IFolderNameSelectorDialogProps {
    show: boolean,
    onCreateFolder: (name: string) => void,
    onHide: () => void,
    loading?: boolean,
    currentFolder: string,
    existingFolders: Array<string>,
}

/**
 * Folder Name Selector Dialog state
 */
interface IFolderNameSelectorDialogState {
    folderName: string
}

/**
 * Folder Name Selector Dialog component
 */
class FolderNameSelectorDialog extends React.Component<IFolderNameSelectorDialogProps, IFolderNameSelectorDialogState> {

    /**
     * Constructor
     */
    constructor(props: IFolderNameSelectorDialogProps) {
        super(props);

        this.state = {
            folderName: "",
        }
    }

    /**
     * Allow component to render
     * @param nextProps next props
     * @param nextState next state
     */
    shouldComponentUpdate(nextProps: Readonly<IFolderNameSelectorDialogProps>, nextState: Readonly<IFolderNameSelectorDialogState>): boolean {
        return this.props.show || nextProps.show;
    }

    /**
     * When component has updated
     * @param prevProps previous props
     * @param prevState previous state
     */
    componentDidUpdate(prevProps: Readonly<IFolderNameSelectorDialogProps>, prevState: Readonly<IFolderNameSelectorDialogState>) {
        if (prevProps.show && !this.props.show)
            this.setState({folderName: ""});
    }

    /**
     * Is folder existing
     */
    isFolderExisting = () => {
        return this.props.existingFolders.includes(this.props.currentFolder + this.state.folderName + "/");
    }

    /**
     * Render component
     */
    render() {
        return (
            <Dialog
                closeOnOutsideClick={false}
                styles={{maxWidth: "600px"}}
                open={this.props.show}
                confirmButton={{
                    disabled: this.state.folderName.length === 0 || this.props.loading || this.isFolderExisting(),
                    loading: this.props.loading,
                    content: languageObject.translate("Confirm"),
                    onClick: () => this.props.onCreateFolder(this.state.folderName)
                }}
                content={
                    <Flex column>
                        <EditInput
                            disabled={this.props.loading}
                            required
                            errorMessage={this.isFolderExisting() ? languageObject.translate("FolderAlreadyExistingWithThisName") : ""}
                            max={50}
                            label={languageObject.translate("FolderName")}
                            value={this.state.folderName}
                            setValue={(value: string) => (value.length === 0 || value.match(/^[a-zA-Z0-9-_ ]+$/)) ?
                                this.setState({folderName: value}) : null}
                        />
                        <Text styles={{color: "gray", marginTop: "5px"}}
                              content={languageObject.translate("AvailableCharsFolderName")}/>
                    </Flex>
                }
                header={languageObject.translate("NewSubFolder")}
                headerAction={{
                    icon: <CloseIcon outline/>,
                    title: 'Close',
                    onClick: this.props.onHide,
                }}/>
        );
    }
}

export default FolderNameSelectorDialog;